package com.mps.asc_app.di

import com.mps.asc_app.data.auth.AuthRepository
import com.mps.asc_app.data.auth.AuthRepositoryImpl
import com.mps.asc_app.data.bookings.BookingRepositoryImpl
import com.mps.asc_app.data.bookings.BookingsRepository
import com.mps.asc_app.data.config.ConfigRepository
import com.mps.asc_app.data.config.ConfigRepositoryImpl
import com.mps.asc_app.data.functions.FunctionsRepository
import com.mps.asc_app.data.functions.FunctionsRepositoryImpl
import com.mps.asc_app.data.places.GooglePlacesRepository
import com.mps.asc_app.data.places.GooglePlacesRepositoryImpl
import com.mps.asc_app.data.places.PlacesRepository
import com.mps.asc_app.data.places.createPlacesRepository
import com.mps.asc_app.data.user.UserRepository
import com.mps.asc_app.data.user.UserRepositoryImpl
import com.mps.asc_app.domain.places.usecase.AutocompleteAddressUseCase
import com.mps.asc_app.domain.places.usecase.ValidateAddressUseCase
import com.mps.asc_app.presentation.AdminPanelViewModel
import com.mps.asc_app.presentation.BookingViewModel
import com.mps.asc_app.presentation.MainViewModel
import com.mps.asc_app.util.TodayDate
import org.koin.core.module.Module
import org.koin.dsl.module

fun appModule(
    httpClientProvider: () -> io.ktor.client.HttpClient,
    googlePlacesApiKey: String,
    todayProvider: () -> TodayDate
): Module = module {

    single { httpClientProvider() }

    single { AutocompleteAddressUseCase(get()) }
    single<PlacesRepository> { createPlacesRepository(get()) }

    single<GooglePlacesRepository> {
        GooglePlacesRepositoryImpl(
            http = get(),
            apiKey = googlePlacesApiKey
        )
    }

    single { ValidateAddressUseCase(get()) }
    single<AuthRepository> { AuthRepositoryImpl() }
    single<UserRepository> { UserRepositoryImpl() }
    single<ConfigRepository> { ConfigRepositoryImpl() }
    single<BookingsRepository> { BookingRepositoryImpl() }
    single<FunctionsRepository> {
        // FunctionsRepositoryImpl benötigt HttpClient + AuthRepository (für Bearer-Token bei HTTP Functions)
        FunctionsRepositoryImpl(
            httpClient = get(),
            authRepository = get()
        )
    }

    factory {
        MainViewModel(
            authRepository = get(),
            functionsRepository = get(),
            userRepository = get(),
            configRepository = get(),
            validateAddressUseCase = get(),
            autocompleteAddress = { query ->
                get<AutocompleteAddressUseCase>()(query)
            },
            verifyAndSaveUserProfile = { uid, firstName, lastName, email, placeId ->
                get<FunctionsRepository>().verifyAndSaveUserProfile(
                    uid = uid,
                    firstName = firstName,
                    lastName = lastName,
                    email = email,
                    placeId = placeId
                )
            },
            savePhoneNumber = { _, _ ->
                Result.success(Unit)
            },
        )
    }

    factory {
        BookingViewModel(
            get(),
            get(),
            get(),
            todayProvider
        )
    }

    factory {
        AdminPanelViewModel(
            userRepository = get(),
            functionsRepository = get()
        )
    }
}